import { AvatarAndNameRender } from 'module/ui/components/molecules/ag-grid-renderer/cell-renderer/AvatarAndNameRender';
import { CsatRatingRenderer } from 'module/ui/components/molecules/ag-grid-renderer/cell-renderer/csat-renderer';
import { CurrencyValueCellRenderer as CurrencyRenderer } from 'module/ui/components/molecules/ag-grid-renderer/cell-renderer/currency-renderer';
import { HoursMinutesRenderer } from 'module/ui/components/molecules/ag-grid-renderer/cell-renderer/hours-minutes-renderer';
import { NoteFieldRenderer } from 'module/ui/components/molecules/ag-grid-renderer/cell-renderer/note-field-renderer';
import { PercentageRenderer } from 'module/ui/components/molecules/ag-grid-renderer/cell-renderer/percentagerenderer';
import { Skeleton } from 'antd';
import { useMemo } from 'react';
import styled from 'styled-components';
import type {
  GetRowIdParams,
  GridOptions,
  PostProcessPopupParams,
} from 'ag-grid-community';

const Loading = styled(Skeleton)`
  margin-top: 20px;
  margin-left: var(--layout-03);
`;

export const LoadingCell = Loading;

export const DEFAULT_GRID_OPTIONS: GridOptions = {
  noRowsOverlayComponent: 'ListEmptyState',
  loadingCellRenderer: LoadingCell,
  getRowId: (d: GetRowIdParams) => d.data.companyId.toString(),
  rowModelType: 'serverSide',
  cacheBlockSize: 100,
  components: {
    AvatarAndNameRender,
    HoursMinutesRenderer,
    PercentageRenderer,
    NoteFieldRenderer,
    CurrencyRenderer,
    CsatRatingRenderer,
  },
  maxConcurrentDatasourceRequests: 2,
  infiniteInitialRowCount: 10,
  maxBlocksInCache: 3,
  rowBuffer: 10,
  blockLoadDebounceMillis: 100,
  suppressScrollOnNewData: true,
  suppressCellFocus: true,
  suppressContextMenu: true,
  suppressFocusAfterRefresh: true,
  suppressMaintainUnsortedOrder: true,
  suppressDragLeaveHidesColumns: true,
  debounceVerticalScrollbar: true,
  suppressMaxRenderedRowRestriction: true,
  valueCache: true,
  animateRows: true,
  enableCellChangeFlash: true,
  suppressRowClickSelection: true,
  suppressRowDeselection: true,
  postProcessPopup: ({ ePopup, column, rowNode }: PostProcessPopupParams) => {
    if (column?.getId() !== 'status' || rowNode?.id !== 'provisional') {
      return;
    }

    ePopup.style.border = '2px solid var(--blue-60)';
    ePopup.style.borderRadius = '0';
  },
  defaultColDef: {
    resizable: true,
    sortable: true,
    editable: false,
    lockPinned: true,
    suppressMovable: true,
    suppressHeaderMenuButton: true,
    cellEditorPopup: true,
    cellEditorPopupPosition: 'over',
  },
};

export const useGridOptions = (handleGridChange) => {
  return useMemo(() => {
    return {
      ...DEFAULT_GRID_OPTIONS,
      onSortChanged: handleGridChange,
      onColumnVisible: handleGridChange,
      onColumnRowGroupChanged: handleGridChange,
      onColumnMoved: handleGridChange,
    };
  }, [handleGridChange]);
};
